import { makeStyles } from "@fluentui/react-components";

export const useAppStyles = makeStyles({
    root: {
      marginRight: "0",
      display: "flex",
      flexDirection: "column",
      flexGrow: 1,
      position: "relative",
    },
    primaryContainer: {
      display: "flex",
      flexDirection: "column",
      flexGrow: 1,
      minHeight: "100vh",
    },
  });
